var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-loading circle"},[_c('svg',{style:({ width: _vm.size }),attrs:{"x":"0px","y":"0px","viewBox":"0 0 150 150"}},[_c('circle',{staticClass:"loading-inner",attrs:{"cx":"75","cy":"75","r":"60"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }